import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getCarts,
  syncCartItems,
} from "../../services/productService";
import useLogin from "../Hooks/useLogin";
import FormatPrice from "../../FormatPrice";
import { getLocalUserId } from "../../utils/getLocalUserId";
import { getToken } from "../../utils/getToken";
import { getProfileFromResponse, getProfileUserId, getUserDetails } from "../../services/Users";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { FaRegAddressCard } from "react-icons/fa6";
import { MdOutlinePayment } from "react-icons/md";
import { Helmet } from "react-helmet";
import { buildCartEventPayload, META_PIXEL_EVENTS, trackMetaEvent } from "../../utils/metaPixel";

function Cart() {
  const navigate = useNavigate();
  const { isLogin } = useLogin();
  //   const { selectedCountrySymbol } = useContext(CountryContext);
  const queryClient = useQueryClient();
  const token = getToken();
  const { data: userProfile } = useQuery({
    queryKey: ["auth-user-details", token],
    queryFn: getUserDetails,
    enabled: Boolean(token),
    retry: false,
  });
  const profileUserId = getProfileUserId(getProfileFromResponse(userProfile));
  const user_id = token ? profileUserId : getLocalUserId();

  useEffect(() => {
    if (token && profileUserId) {
      localStorage.setItem("user_id", String(profileUserId));
    }
  }, [profileUserId, token]);

  const { data: cartData } = useQuery({
    queryKey: ["get-cart", { user_id }],
    queryFn: getCarts,
    enabled: Boolean(user_id),
  });

  const mutateSyncCart = useMutation({
    mutationKey: ["sync-cart"],
    mutationFn: syncCartItems,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-cart"] });
    },
  });
  const carts = Object.values(cartData?.data?.data || {});

  useEffect(() => {
    window.scrollTo(0,0);
     },[])

  const updateItem = (item, quantity) => {
    const nextCarts = carts
      .map((cartItem) =>
        String(cartItem.product_id) === String(item.product_id)
          ? { ...cartItem, quantity }
          : cartItem
      )
      .filter((cartItem) => Number(cartItem.quantity) > 0);

    localStorage.setItem(
      "carts",
      JSON.stringify(
        Object.fromEntries(
          nextCarts.map((cartItem) => [String(cartItem.product_id), cartItem])
        )
      )
    );
    mutateSyncCart.mutate({ user_id, items: nextCarts });
  };

  const removeItem = (item) => {
    const nextCarts = carts.filter(
      (cartItem) => String(cartItem.product_id) !== String(item.product_id)
    );

    localStorage.setItem(
      "carts",
      JSON.stringify(
        Object.fromEntries(
          nextCarts.map((cartItem) => [String(cartItem.product_id), cartItem])
        )
      )
    );
    mutateSyncCart.mutate({ user_id, items: nextCarts });
  };

  const totalPrice = carts.reduce(
    (acc, cart) => acc + cart.price * cart.quantity,
    0
  );
  const shipping = 0;
  const qualityCheck = 0;
  return (
    <>
       <Helmet>
  <title>KUKUNAMKEEN | Kachori | SWEETS | Free Shipping | Indian Snacks</title>
        <meta name="description" content= "KUKUNAMKEEN - Your Destination for Authentic Indian Snacks. Explore our range of Kachori, Sweets, and more. Enjoy Free Shipping on all orders"/>
        <meta name="keywords" content="KUKUNAMKEEN, Kachori, Sweets, Free Shipping, Indian Snacks"/>
        <link rel="canonical" href={`https://kukunamkeen.in/add-to-cart`} />

</Helmet>
    <div>
      <div className=" mt-24 lg:mt-24 container mx-auto px-4 sm:px-6 lg:px-8 md:mt-24 sm:mt-24 flex flex-col md:flex-row lg:flex-row xl:flex-row items-center justify-center gap-0 lg:gap-24 xl:gap-24 w-full">
        {carts.length > 0 ? (
          <>
            <div className="flex flex-col w-full  md:mr-3">
              {carts?.map((item) => (
                <div className="w-full mb-5">
                  <div className="flex flex-col space-y-5">
                    <div>
                      <div
                        className="flex-col shadow rounded-2xl flex px-2 py-2 items-center justify-between"
                        style={{ border: "1px solid #a5a5a5" }}
                      >
                      <div className=" flex w-full ">
                      <div className="sm:text-sm">
                              <h1
                                className="chrome sm:text-sm font-medium"
                                style={{ color: "#1E1E1E" }}
                              >
                                {item?.product_name}
                              </h1>
                            </div>
                      </div>


<div className="flex align-middle w-full space-x-4">


                        <div className="flex flex-grow flex-col">
                          <div className="flex items-center justify-between">
                          <img
                          src={item?.thumbnail_image}
                          className="w-20 h-20 rounded-lg mr-4"
                          alt={item?.product_name}
                        />

                            <div className="flex items-center space-x-2 bg-[#F3F3F3] rounded-2xl px-4 py-2">
                              <button
                                className="cursor-pointer w-6 h-6"
                                style={{ color: "#952F8A" }}
                                onClick={() =>
                                  updateItem(item, item.quantity - 1)
                                }
                              >
                                -
                              </button>
                              <span
                                className="mr-2"
                                style={{ color: "#952F8A" }}
                              >
                                {item?.quantity}
                              </span>
                              <button
                                className="cursor-pointer w-6 h-6"
                                style={{ color: "#952F8A" }}
                                onClick={() =>
                                  updateItem(item, item.quantity + 1)
                                }
                              >
                                +
                              </button>
                            </div>
                            <div className="flex gap-10">
                              <h2 className="text-lg ">
                                <FormatPrice price={item.price} />
                              </h2>
                              <button
                                className="cursor-pointer"
                                onClick={() => removeItem(item)}
                              >
                                <img
                                  src="/Image/Trash.svg"
                                  alt="Delete"
                                  className="w-8 h-8 cursor-pointer"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="w-full lg:w-3/4 xl:w-3/4 mb-5"
              style={{ marginLeft: "auto" }}
            >
              <div className=" p-0">
                <div
                  className="bg-white shadow rounded-lg p-4 justify-center flex mb-4"
                  style={{
                    border: "1px solid #a5a5a5",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div className="justiy-center ">
                    <p style={{ display: "flex", flexDirection: "row" }}>
                      <span
                        style={{
                          color: "rgb(0,179,149)",
                          fontWeight: "bold",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <HiOutlineShoppingCart size={25} /> Cart
                      </span>
                      <span
                        style={{
                          color: "gray",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        ------{" "}
                        <FaRegAddressCard
                          size={25}
                          style={{ marginLeft: "3px", marginRight: "4px" }}
                        />{" "}
                        Address------{" "}
                        <MdOutlinePayment
                          size={25}
                          style={{ marginLeft: "3px", marginRight: "1px" }}
                        />
                        Payment
                      </span>
                    </p>
                  </div>
                </div>

                <div
                  className="bg-white shadow rounded-lg p-4"
                  style={{ border: "1px solid #a5a5a5", borderRadius: "10px" }}
                >
                  {carts?.map((item) => (
                    <div className="flex items-center justify-between mb-2">
                      <h2>{item?.product_name}</h2>
                      <span>
                        <FormatPrice price={item.price * item.quantity} />
                      </span>
                    </div>
                  ))}
                  <hr className="border-t border-gray-400 my-4" />
                  <div className="mb-4">
                    <div className="flex items-center justify-between mb-2">
                      <span>Subtotal</span>
                      <span>
                        <FormatPrice
                          price={carts.reduce(
                            (acc, cart) => acc + cart.price * cart.quantity,
                            0
                          )}
                        />
                      </span>
                    </div>
                    {/* <div className="flex items-center justify-between mb-2">
                      <span>Shipping</span>
                      <span>
                        <FormatPrice price={shipping} />
                      </span>
                    </div>
                    <div className="flex items-center justify-between mb-2">
                      <span>Quality Check</span>
                      <span>
                        <FormatPrice price={qualityCheck} />
                      </span>
                    </div> */}
                  </div>

                  {/* <div className="flex items-center justify-between mb-4 font-bold">
                    <span>Total (Tax incl.)</span>
                    <span>
                      <FormatPrice
                        price={totalPrice + shipping + qualityCheck}
                      />
                    </span>
                  </div> */}
                  <div className="">
                    <button
                      type="button"
                      className="bg-[#952F8A] text-white rounded-lg text-xl py-3 px-4 w-full mt-4 hover:opacity-90 transition-opacity"
                      onClick={() => {
                        trackMetaEvent(
                          META_PIXEL_EVENTS.INITIATE_CHECKOUT,
                          buildCartEventPayload(carts)
                        );
                        navigate("/checkout");
                      }}
                    >
                      Proceed to Checkout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center">
            <h1 className=" mt-2 text-2xl font-semibold">
              Your cart is currently empty!
            </h1>
            <button
              className="rounded text-white p-2 w-48 mt-4"
              style={{ backgroundColor: "rgb(162,0,141)" }}
            >
              <Link to="/categories">Continue Shopping</Link>
            </button>
          </div>
        )}
      </div>
      <div className="mt-32"></div>
    </div>
    </>
  );
}

export default Cart;
